"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.requestAnimationFrameAsync = exports.setTimeoutAsync = exports.getScroll = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

exports.getNode = getNode;
exports.getOffsetTop = getOffsetTop;
exports.scrollTo = scrollTo;

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// github.com/ant-design/ant-design/blob/master/components/anchor/Anchor.tsx@a2e0e40

function getNode(node) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$replaceBodyWithW = _ref.replaceBodyWithWindow,
        replaceBodyWithWindow = _ref$replaceBodyWithW === undefined ? false : _ref$replaceBodyWithW;

    if (typeof node === "function") {
        node = node();
    }
    if (typeof node === "string") {
        node = document.getElementById(node);
    } else {
        try {
            node = _reactDom2.default.findDOMNode(node);
        } catch (err) {}
    }
    if (node == document.body && replaceBodyWithWindow) {
        return window;
    }
    return node;
}

var getScroll = exports.getScroll = function getScroll(target, top) {
    return target === window ? target[top ? "pageYOffset" : "pageXOffset"] : target[top ? "scrollTop" : "scrollLeft"];
};

function getOffsetTop(element, container) {
    if (!element.getClientRects().length) {
        return 0;
    }
    var rect = element.getBoundingClientRect();

    if (rect.width || rect.height) {
        if (container === window) {
            container = element.ownerDocument.documentElement;
            return rect.top - container.clientTop;
        }
        return rect.top - container.getBoundingClientRect().top;
    }

    return rect.top;
}

function easeInOutLinear(toffset, from, to, duration) {
    var cc = to - from;
    return from + toffset / duration * cc;
}

function easeInOutCubic(toffset, from, to, duration) {
    var cc = to - from;
    toffset /= duration / 2;
    if (toffset < 1) {
        return cc / 2 * toffset * toffset * toffset + from;
    }
    return cc / 2 * ((toffset -= 2) * toffset * toffset + 2) + from;
}

var doScroll = function doScroll(container, scrollTop) {
    if (container == window || container == document.body) {
        window.scrollTo(window.pageXOffset, scrollTop);
    } else {
        container.scrollTop = scrollTop;
    }
};

function scrollTo(targetElement, container, _ref2) {
    var animation = _ref2.animation;

    var scrollTop = getScroll(container, true);
    var eleOffsetTop = getOffsetTop(targetElement, container);
    var offsetTop = 0;
    var targetScrollTop = scrollTop + eleOffsetTop - offsetTop;

    var tsStart = Date.now();
    var ANIM_SPEED = 24;
    var ANIM_DURATION = // 450;
    Math.max(84, Math.min(384, Math.abs(targetScrollTop - scrollTop) / ANIM_SPEED));
    var tsEnd = tsStart + ANIM_DURATION;

    var update = function update() {
        var ts = Date.now();
        if (ts < tsEnd && animation) {
            var toffset = ts - tsStart;
            doScroll(container, easeInOutCubic(toffset, scrollTop, targetScrollTop, ANIM_DURATION));
            requestAnimationFrame(update);
        }
        if (ts >= tsEnd || !animation) {
            doScroll(container, targetScrollTop);
        }
    };

    requestAnimationFrame(update);
}

var setTimeoutAsync = exports.setTimeoutAsync = function setTimeoutAsync(timeout) {
    return new _promise2.default(function (resolve) {
        return setTimeout(resolve, timeout);
    });
};

var requestAnimationFrameAsync = exports.requestAnimationFrameAsync = function requestAnimationFrameAsync() {
    return new _promise2.default(requestAnimationFrame);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-anchor@0.0.6@@alicd/crui-anchor/lib/util.js
// module id = 258
// module chunks = 0